import type { PageCard } from '@/play/pageTypes'
import { FramesCardArt } from './CardArt'

/** What the home screen shows for this page; the page itself is ./index.ts, loaded when it opens. */
export const card: PageCard = {
  id: 'frames',
  number: 33,
  title: 'Frames',
  question: 'Does a painting feel finished and special when it has a frame, a background and a setting around it?',
  status: 'open',
  accent: '#e8d29a',
  CardArt: FramesCardArt,
}
